import React from 'react';
import './sass/assembly.scss';

function Assembly({
  fulfillmentDetails
}) {
    let displayText = '';
    if(fulfillmentDetails.isAssemblyEligible && fulfillmentDetails.inStoreAssemblyAvailable) {
        displayText = "Choosing Store Pickup or Express Delivery?";
    } else if(fulfillmentDetails.inStoreAssemblyAvailable)  {
        displayText = "Choosing Store Pickup?";
    } else if (fulfillmentDetails.isAssemblyEligible){
        displayText = "Choosing Express Delivery?";
    }

    if(displayText){
      return (
        <div className="assembly__wrapper">
            <span className="assembly__message">
                <span className="assembly__message-ffm u__bold">{displayText}&nbsp;</span>
                <span className="assembly__message-body">We can assemble it for <span className="u__text--success">FREE</span>, just select assembly in cart.</span>
            </span>
        </div>
      );
    }else{
      return null;
    }
}

export default Assembly;
